import { getServiceTrackingUrl } from "../utils/getServiceTrackingUrl";
import { TRACKING_FETCH_TIMEOUT } from "../../consts";
import { fetchTimeout } from "utils";
import type { BeaconTracksSenderBody } from "../types";
import { shouldSendToEndpoint } from "./senderTrafficLimiter";
import type { DataWarehouseEndpointSuffix } from "instant-config";

export function send(
  endpoint: DataWarehouseEndpointSuffix,
  data: BeaconTracksSenderBody,
): void {
  if (!shouldSendToEndpoint(endpoint)) {
    return;
  }
  const serviceUrl = `${getServiceTrackingUrl()}${endpoint}`;
  const params: BeaconTracksSenderBody = {
    ...data,
  };

  const searchParams = new URLSearchParams(Object.entries(params));

  fetchTimeout(
    `${serviceUrl}?${searchParams.toString()}`,
    TRACKING_FETCH_TIMEOUT,
    {
      mode: "no-cors",
    },
  ).catch((e) => console.warn("Failed to send request to Beacon service", e));
}
